<div *ngIf="observableLocales$ | async as placeholderLocales" class="iframe-div">
    <main class="row iframe-row-div">
        @if (action=="optout") {
            <p class="sr-only">Opt out, iFrame.</p>
        }
        @else {
            <p class="sr-only">All available opt actions, iFrame.</p>
        }       
        <section id="instructions-heading" *ngIf="(hasInstructionsLocale() | async)" class="instruction-container" aria-labelledby="instructions-heading">
            <div class="instruction">
                <app-locale localeKey="INSTRUCTIONS" localeView="{{ view }}"></app-locale>
            </div>
        </section>
        <div class="iframe-row-item">
            <form [formGroup]="customerForm" #formDir="ngForm" novalidate (ngSubmit)="submit.focus(); OnSubmit()"
                  class="container-fluid info-form">
                <div>
                    <h3 class="form-block center">
                        <app-locale localeKey='ACCT_HEADER' localeView='CUSTOMER'></app-locale>
                    </h3>
                    <div class="form-block sample-bill-link-div center">
                        <small>
                            <a prevent-default (click)="openDialog()" (keydown.enter)="openDialog()" 
                               class="sample-bill-link" role="button" tabindex="0">
                                <app-locale localeKey="SAMPLE_BILL_URL_LABEL" localeView="CUSTOMER"></app-locale>
                            </a>
                        </small>
                    </div>
                    <div *ngIf="validation_errors.length > 0" role="alert" aria-live="polite" aria-atomic="true">
                        <div class="inline-error" *ngFor="let validation_error of validation_errors">
                            <div *ngIf="validation_error === 'DATE'" [attr.data-automation-id]="'customer-error-date'">
                                <app-dismiss-alert localeKey='{{validation_error}}' localeView='CUSTOMER' alertType='alert-danger'
                                                   closeType='alert-danger-close'>
                                    <span additionalContent>
                                        {{customer.effectiveDate | date : 'shortDate'}}
                                        <app-locale localeKey='CONTACT_US_INFO' localeView='CUSTOMER'></app-locale>
                                    </span>
                                </app-dismiss-alert>
                            </div>
                            <div *ngIf="validation_error === 'OPT_OUT_RESTRICTED'"
                                 [attr.data-automation-id]="'customer-error-optout-restricted'">
                                <app-dismiss-alert localeKey='{{validation_error}}' localeView='CUSTOMER' alertType='alert-danger'
                                                   closeType='alert-danger-close'>
                                    <span additionalContent>
                                        <a [routerLink]="['/alt', 'optout', lang, accountId]">
                                            <app-locale localeKey='OPT_OUT_RESTRICTED_CONTINUE' localeView='CUSTOMER'></app-locale>
                                        </a>
                                    </span>
                                </app-dismiss-alert>
                            </div>
                            <div *ngIf="validation_error === 'NO_PROGRAM_OPTIONS'" [attr.data-automation-id]="'customer-error-program-options'">
                                <app-dismiss-alert localeKey='{{validation_error}}' localeView='CUSTOMER' alertType='alert-danger'
                                                   closeType='alert-danger-close'></app-dismiss-alert>
                            </div>
                            <div *ngIf="validation_error !== 'DATE' && validation_error !== 'OPT_OUT_RESTRICTED' && validation_error !== 'NO_PROGRAM_OPTIONS'"
                                 [attr.data-automation-id]="'customer-error-not-found'">
                                <app-dismiss-alert localeKey='{{validation_error}}' localeView='CUSTOMER' alertType='alert-danger'
                                                   closeType='alert-danger-close'></app-dismiss-alert>
                            </div>
                        </div>
                    </div>
                    <br aria-hidden="true">
                    <div class="am-fade-and-scale">
                        <div>
                            <label class="input-label" for="accountNumber">
                                <app-locale localeKey='ACCT_NUM_LABEL' localeView='CUSTOMER'></app-locale>
                            </label>
                            <app-required [attr.data-automation-id]="'customer-required-acctnum'"></app-required>
                            <app-tooltip localeKey='ACCT_NUM_TOOLTIP' localeView='CUSTOMER' tooltipKey="TOOLTIP_IMG"
                                         tooltipView="IFRAME"></app-tooltip>
                        </div>
                        <input localeplaceholder='ACCT_NUM_PLACEHOLDER' localeview='CUSTOMER'
                               class="form-control text-inline customer-page-input" required
                              id="accountNumber" formControlName="accountNumber" [attr.data-automation-id]="'customer-txt-acctnum'" 
                              [maxLength]="inputAccountLength" aria-required="true" 
                              [attr.aria-describedby]="accountNumber.invalid && (accountNumber.dirty || accountNumber.touched) ? 'accountNumber-error' : null">
                        <div class="validation-summary-block">
                            <div id="accountNumber-error" class="validation-summary"
                                 *ngIf="accountNumber.invalid && (accountNumber.dirty || accountNumber.touched)" role="alert" aria-live="polite">
                                <div *ngIf="accountNumber.errors.required; else acctNumericErr " class="text-danger">
                                    <app-locale localeKey='ACCT_REQ_ERR' localeView='CUSTOMER'></app-locale>
                                </div>
                                <ng-template #acctNumericErr>
                                    <div *ngIf="accountNumber.errors.numeric; else acctLengthErr" class="text-danger">
                                        <app-locale localeKey='ACCT_INVALID_ERR' localeView='CUSTOMER'></app-locale>
                                    </div>
                                </ng-template>
                                <ng-template #acctLengthErr>
                                    <div *ngIf="accountNumber.errors.minlength || accountNumber.errors.maxlength"
                                         class="text-danger">
                                        <app-locale localeKey='ACCT_INVALID_ERR_2' localeView='CUSTOMER'></app-locale>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="am-fade-and-scale">
                        <div>
                            <label class="input-label" for="name">
                                <app-locale localeKey='ACCT_NAME' localeView='CUSTOMER'></app-locale>
                            </label>
                            <app-required [attr.data-automation-id]="'customer-required-name'"></app-required>
                            <app-tooltip localeKey='ACCT_NAME_TOOLTIP' localeView='CUSTOMER' tooltipKey="TOOLTIP_IMG"
                                         tooltipView="IFRAME"></app-tooltip>
                        </div>
                        <input id="name" localeplaceholder='ACCT_NAME_PLACEHOLDER' localeview='CUSTOMER'
                               class="form-control text-inline customer-page-input" required formControlName="name"
                               [attr.data-automation-id]="'customer-txt-acctname'" aria-required="true"
                               [attr.aria-describedby]="name.invalid && (name.dirty || name.touched) ? 'name-error' : null">
                        <div class="validation-summary-block">
                            <div id="name-error" class="validation-summary" *ngIf="name.invalid && (name.dirty || name.touched)" role="alert" aria-live="polite">
                                <div *ngIf="name.errors.required; else acctSpaceErr" class="text-danger">
                                    <app-locale localeKey='ACCT_NAME_REQ_ERR' localeView='CUSTOMER'></app-locale>
                                </div>
                                <ng-template #acctSpaceErr>
                                    <div *ngIf="name.errors.space" class="text-danger">
                                        <app-locale localeKey='ACCT_NAME_REQ_ERR' localeView='CUSTOMER'></app-locale>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="am-fade-and-scale">
                        <div>
                            <label class="input-label" for="zipcode">
                                <app-locale localeKey='ACCT_ZIP_CODE' localeView='CUSTOMER'></app-locale>
                            </label>
                            <app-required [attr.data-automation-id]="'customer-required-zip'"></app-required>
                        </div>
                        <input id="zipcode" localeplaceholder='ACCT_ZIP_PLACEHOLDER' localeview='CUSTOMER'
                               class="form-control text-inline customer-page-input" required formControlName="zipcode"
                               [attr.data-automation-id]="'customer-txt-acctzip'" maxlength="{{inputZipLength}}"
                               aria-required="true" [attr.aria-describedby]="zipcode.invalid && (zipcode.dirty || zipcode.touched) ? 'zipcode-error' : null">
                        <div class="validation-summary-block">
                            <div id="zipcode-error" class="validation-summary"
                                 *ngIf="zipcode.invalid && (zipcode.dirty || zipcode.touched)" role="alert" aria-live="polite">
                                <div *ngIf="zipcode.errors.required; else zipNumericErr" class="text-danger">
                                    <app-locale localeKey='ACCT_ZIP_CODE_REQ_ERR' localeView='CUSTOMER'>
                                    </app-locale>
                                </div>
                                <ng-template #zipNumericErr>
                                    <div *ngIf="zipcode.errors.numeric; else zipLengthErr" class="text-danger">
                                        <app-locale localeKey='ACCT_ZIP_CODE_INVALID_ERR' localeView='CUSTOMER'>
                                        </app-locale>
                                    </div>
                                </ng-template>
                                <ng-template #zipLengthErr>
                                    <div *ngIf="(zipcode.errors.minlength || zipcode.errors.maxlength)"
                                         class="text-danger">
                                        <app-locale localeKey='ACCT_ZIP_CODE_INVALID_ERR_2' localeView='CUSTOMER'>
                                        </app-locale>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isAltFormRequired" class="checkbox alt-checkbox-margin missing-account">
                        <label class="container-checkbox-label">
                            <input type="checkbox" formControlName="isNavigatingToAltForm"
                                   id="navigatingToAltForm" [attr.data-automation-id]="'customer-chk-navtoalt'" />
                            <span class="checkbox-custom"></span>
                            <app-locale localeKey='ACCT_NOT_AVAILABLE_LABEL' localeView='CUSTOMER'></app-locale>
                        </label>
                    </div>
                    <div>
                        <button #submit type="submit" class="btn btn-success btn-customer" [disabled]="isSubmitting" style="width: 100%;"
                                [attr.data-automation-id]="'customer-btn-submit'"
                                [attr.aria-label]="isSubmitting ? 'Submitting, please wait' : null">
                            <app-locale *ngIf="!isSubmitting" localeKey='NEXT_BTN' localeView='IFRAME'></app-locale>
                            <mat-icon *ngIf="isSubmitting" aria-live="polite" aria-atomic="true">
                                <mat-spinner diameter="24"></mat-spinner>
                            </mat-icon>
                        </button>
                    </div>
                    <br aria-hidden="true">
                    <div>
                        <app-required [attr.data-automation-id]="'customer-required-text'"></app-required>
                        <span class="required-note" aria-hidden="true">
                            <app-locale localeKey='REQUIRED_NOTE' localeView='IFRAME'></app-locale>
                        </span>
                    </div>
                </div>
            </form>
        </div>
    </main>
</div>